import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import type { CalendarEventType, ScheduleRequestCalendarEvent } from '../../../types';

interface Props {
  event: ScheduleRequestCalendarEvent;
}
export const ScheduleRequestEvent = ({ event }: Props) => {
  return (
    <div data-event-type={'scheduleRequest' satisfies CalendarEventType} css={containerStyle}>
      {event.eventType}
    </div>
  );
};

const containerStyle = css({
  padding: theme.spacing(0.5),
  borderRadius: theme.borderRadius.small,
  boxShadow: theme.shadows.light,
  // TODO: change color
  background: 'rgba(98, 100, 244, 0.1)',
  border: '1.5px dashed #6264F4',
});
